/**
 * Set focus on first element holding `.focusOnLoad`
 * In case we have a ?error in the url set the focus on first `.focusOnError`
 */

class FocusOnLoad {
  static setFocus(focusElement) {
    focusElement.focus();
  }

  static checkForFocus() {
    const focusElement = document.querySelector('.focusOnLoad');
    if (!focusElement) return;
    FocusOnLoad.setFocus(focusElement);
  }

  static checkForError() {
    const urlQuery = window.location.search;
    if (urlQuery !== '?error') return;
    const focusElement = document.querySelector('.focusOnError');
    if (!focusElement) return;
    FocusOnLoad.setFocus(focusElement);
  }

  static init() {
    this.checkForFocus();
    this.checkForError();
    console.log('Focus init : ok');
  }
}

export default FocusOnLoad;
